import { createApp } from 'vue'
import ElementUI from 'element-plus'
import 'element-plus/theme-chalk/el-reset.css'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuex from 'vuex';
import Axios from 'axios';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'


Axios.defaults.headers.common['Authorization'] = `Bearer ${store.state.token}`;
Axios.defaults.headers.post['Content-Type'] = 'application/json';

const app = createApp(App).use(Vuex).use(store).use(router);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.use(ElementUI);
app.mount('#app');
